import React from 'react';

const GAP = 3; // px gap along the ring between adjacent slices

// data: [{ label, value, color, formattedValue }]
const PieChart = ({ data, size = 160, thickness = 28 }) => {
  const total = data.reduce((sum, d) => sum + (d.value > 0 ? d.value : 0), 0);
  const cx = size / 2;
  const cy = size / 2;
  const r = (size - thickness) / 2;
  const circumference = 2 * Math.PI * r;

  let offset = 0;
  const slices = total > 0 ? data
    .filter(d => d.value > 0)
    .map((d) => {
      const dash = (d.value / total) * circumference;
      const slice = {
        ...d,
        dasharray: `${Math.max(dash - GAP, 0)} ${circumference - dash + GAP}`,
        dashoffset: -offset,
      };
      offset += dash;
      return slice;
    }) : [];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap' }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label="สัดส่วนรายรับ">
        <g transform={`rotate(-90 ${cx} ${cy})`}>
          {slices.length > 0 ? slices.map((s, i) => (
            <circle
              key={i}
              cx={cx}
              cy={cy}
              r={r}
              fill="none"
              stroke={s.color}
              strokeWidth={thickness}
              strokeDasharray={s.dasharray}
              strokeDashoffset={s.dashoffset}
            />
          )) : (
            <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e1e0d9" strokeWidth={thickness} />
          )}
        </g>
      </svg>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {data.map((d, i) => (
          <li key={i} style={{ marginBottom: '10px' }}>
            <div style={{ fontSize: '0.72rem', color: '#898781' }}>{d.label}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ width: '9px', height: '9px', borderRadius: '50%', backgroundColor: d.color, flexShrink: 0 }} />
              <span style={{ fontSize: '0.85rem', color: '#0b0b0b', fontWeight: 600 }}>
                {d.formattedValue} บาท
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PieChart;
